// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./de/(auth)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/_layout.tsx"); } },
  "./de/(auth)/aktuelle-listen.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/aktuelle-listen.tsx"); } },
  "./de/(auth)/gastbestellungen.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/gastbestellungen.tsx"); } },
  "./de/(auth)/index.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/index.tsx"); } },
  "./de/(auth)/lunchpakete.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/lunchpakete.tsx"); } },
  "./de/(auth)/schliesszeiten.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/schliesszeiten.tsx"); } },
  "./de/(auth)/speiseplan.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/(auth)/speiseplan.tsx"); } },
  "./de/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/_layout.tsx"); } },
  "./de/index.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/de/index.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/home/runner/work/luna-restaurant/luna-restaurant/apps/luna-school-app/app/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;